let Global = {
  gameTry: 0,
  delta: 0,

  deviceOrientationAvailable: false,
  soundEnabled: true,
  clockStopped: false,
  taskCompleted: false,
  collectedTotal: 0,
  totalToCollect: 10,
  itemsCollected: [],
  BASE_URL: "https://www.newsfeedsmartapp.com/BBCFactVsFake/",
  URL_CREATE: "https://www.newsfeedsmartapp.com/BBCFactVsFake/create.php",
  URL_DATA: "https://www.newsfeedsmartapp.com/BBCFactVsFake/data.php",
  URL_DATA_QUIZ: "https://www.newsfeedsmartapp.com/BBCFactVsFake/data_quiz.php",
  URL_VUPDATE:
    "https://www.newsfeedsmartapp.com/BBCFactVsFake/valueUpdator.php",
  // URL_UPLOAD:
  //   'https://www.newsfeedsmartapp.com/BBCFactVsFake/api/upload.php',

  // BASE_URL: 'https://www.newsfeedsmartapp.com/BBCFactVsFake/',
  // URL_CREATE: 'https://www.newsfeedsmartapp.com/BBCFactVsFake/quiz/create.php',
  // URL_DATA: 'https://www.newsfeedsmartapp.com/BBCFactVsFake/quiz/data.php',
  // URL_DATA_QUIZ: 'https://www.newsfeedsmartapp.com/BBCFactVsFake/quiz/data_quiz.php',
  // URL_VUPDATE:'https://www.newsfeedsmartapp.com/BBCFactVsFake/quiz/valueUpdator.php',
  URL_UPLOAD:
    "https://www.newsfeedsmartapp.com/BBCFactVsFake/api/upload_quiz.php",

  scenarioItems: {
    conflict: [
      { flak_jacket: 0 },
      { firstaid: 0 },
      { foodpack: 0 },
      { torch: 0 },
      { walkie: 0 },
      { gas_mask: 0 },
      { mic: 0 },
      { tripod: 0 },
      { tent: 0 },
      { sleepy_bag: 0 },
    ],
    cyclone: [
      { life_jacket: 0 },
      { gum_boot: 0 },
      { umbrerlla: 0 },
      { raincoat: 0 },
      { foodpack: 0 },
      { walkie: 0 },
      { battery: 0 },
      { tent: 0 },
      { sleepy_bag: 0 },
      { generator: 0 },
    ],
    remote: [
      { tent: 0 },
      { sleepy_bag: 0 },
      { cookset: 0 },
      { stove: 0 },
      { firstaid: 0 },
      { mosquito: 0 },
      { mic: 0 },
      { walkie: 0 },
      { tripod1: 0 },
      { foodpack: 0 },
    ],
  },
  assets: {
    cubemap: {},
    glbs: {
      room: {
        key: "room",
        path: ["./models/room.glb"],
        asset: null,
      },
    },
    textures: {
      tick: {
        key: "tick",
        path: ["./textures/tick.png"],
        asset: null,
      },
      radGrad: {
        key: "radGrad",
        path: ["./textures/icons/rad-grad.png"],
        asset: null,
      },
    },
    sounds: {},
  },
};
export { Global };
